// app/error.tsx
'use client'

import React from 'react'
import { useEffect } from 'react'

interface ErrorProps {
  error: Error
  reset: () => void
}

const ErrorPage: React.FC<ErrorProps> = ({ error, reset }) => {
  useEffect(() => {
    // Log the error to the console for debugging
    console.error('ErrorPage caught an error:', error)
  }, [error])

  return (
    <div className="container flex items-center justify-center min-h-[70vh] mx-auto">
      <div className="text-center p-4">
        <h1 className="text-4xl font-bold text-slate-900">Something went wrong.</h1>
        <p className="mt-4 text-lg text-gray-700">
          We&apos;re sorry for the inconvenience. Please try refreshing the page.
        </p>
        {process.env.NODE_ENV === 'development' && (
          <pre className="mt-4 text-sm text-gray-600 max-w-full overflow-auto">
            <code className='text-sm break-words whitespace-pre-wrap'>{error.message}</code>
          </pre>
        )}
        <button
          onClick={() => reset()}
          className="mt-6 px-4 py-2 bg-slate-800 text-white rounded hover:bg-slate-950 focus:outline-none focus:ring-2 focus:ring-slate-900"
        >
          Retry
        </button>
      </div>
    </div>
  )
}

export default ErrorPage
